import { IconType } from "react-icons";
import {
  HiOutlineHome,
  HiOutlineUsers,
  HiOutlineUserPlus,
  HiOutlineBuildingOffice2,
  HiOutlineMap,
  HiOutlineCreditCard,
  HiOutlineHomeModern,
  HiOutlineWifi,
  HiOutlineUserGroup,
  HiOutlineSquares2X2,
  HiOutlineTag,
  HiOutlineKey,
  HiOutlineBanknotes,
  HiOutlineArrowPathRoundedSquare,
  HiOutlineBellAlert,
  HiOutlineCog6Tooth,
} from "react-icons/hi2";

interface TAdminLink {
  title: string;
  icon: IconType;
  path: string;
}

export const adminLinks: TAdminLink[] = [
  { title: "الرئيسية", icon: HiOutlineHome, path: "/" },
  { title: "المستخدمين", icon: HiOutlineUsers, path: "/users" },
  {
    title: "طلبات الانضمام كمضيف",
    icon: HiOutlineUserPlus,
    path: "/host-registration",
  },
  { title: "المدن", icon: HiOutlineBuildingOffice2, path: "/cities" },
  { title: "المناطق", icon: HiOutlineMap, path: "/areas" },
  {
    title: "طرق الدفع",
    icon: HiOutlineCreditCard,
    path: "/payment-methods?sorts=sort",
  },
  {
    title: "انواع الاقامة",
    icon: HiOutlineHomeModern,
    path: "/property-types?sorts=sort",
  },
  {
    title: "المرافق",
    icon: HiOutlineWifi,
    path: "/property-amenities?sorts=sort",
  },
  { title: "انواع الضيوف", icon: HiOutlineUserGroup, path: "/guest-types" },
  { title: "أنواع الوحدات", icon: HiOutlineSquares2X2, path: "/unit-types" },
  { title: "الإقامات", icon: HiOutlineTag, path: "/offers" },
  { title: "الحجوزات", icon: HiOutlineKey, path: "/reservations" },
  { title: "التسويات", icon: HiOutlineBanknotes, path: "/settlements" },
  {
    title: "عمليات الشحن",
    icon: HiOutlineArrowPathRoundedSquare,
    path: "/transactions",
  },
  { title: "الإشعارات", icon: HiOutlineBellAlert, path: "/notifications" },
  { title: "الضبط", icon: HiOutlineCog6Tooth, path: "/settings" },
];
